import { config } from '../../auth';

export const cloudSSOEndpoint = config.SSO.SWAP_ENDPOINT;
